export default "__VITE_ASSET__LVP7tNeX__"